import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  Button,
  Link,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide
} from '@material-ui/core';

import { useHistory } from 'react-router-dom';
import { purple } from '@material-ui/core/colors';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  delete: {
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    '&:hover': {
      backgroundColor: purple[700]
    }
  }
}));

const OrdersTable = props => {
  const { className, tickets, onDeleteTicket, ...rest } = props;

  const classes = useStyles();
  let history = useHistory();

  // const [selectedUsers, setSelectedUsers] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleEdit = id => event => {
    history.push(`/order/${id}`);
  };

  const [open, setOpen] = React.useState(false);
  const [ticketDelete, setTicketDelete] = React.useState();

  const handleDeleteDialog = id => event => {
    setTicketDelete(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    setOpen(false);
    onDeleteTicket(ticketDelete);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">{`Вы уверены что хотите удалить билет ${ticketDelete}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            После удаления билет и все платежи нельзя будет востановить.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Не нужно
          </Button>
          <Button onClick={handleDelete} className={classes.delete}>
            Удалить
          </Button>
        </DialogActions>
      </Dialog>

      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Номер</TableCell>
                    <TableCell>Дата</TableCell>
                    <TableCell>Фамилия</TableCell>
                    <TableCell>Тип</TableCell>
                    <TableCell>Стоимость</TableCell>
                    <TableCell>Купоны</TableCell>
                    <TableCell>Даты купонов</TableCell>
                    <TableCell>Статус</TableCell>
                    <TableCell>Действия</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {tickets.slice(0, rowsPerPage).map(user => ( */}
                  {tickets.map(ticket => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={ticket.id}>
                      <TableCell>
                        <Link href="#" onClick={handleEdit(ticket.id)}>
                          {ticket.id}
                        </Link>
                      </TableCell>
                      <TableCell>{ticket.created_at}</TableCell>

                      <TableCell>{ticket.user}</TableCell>

                      <TableCell>
                        {ticket.userType === 7 ? (
                          <Chip
                            // style={{ backgroundColor: 'yellowgreen' }}
                            label={ticket.userTypeLabel}
                          />
                        ) : (
                          ticket.userTypeLabel
                        )}
                      </TableCell>

                      <TableCell>
                        {ticket.price ? ticket.price.toLocaleString('ru') : 0} ฿
                      </TableCell>

                      <TableCell>{ticket.meals}</TableCell>

                      <TableCell>
                        {ticket.meal_min_date} {ticket.meal_max_date}
                      </TableCell>

                      <TableCell>
                        <Chip
                          style={{ backgroundColor: ticket.payedStatusColor }}
                          label={ticket.payedStatusLabel}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          className={classes.delete}
                          onClick={handleDeleteDialog(ticket.id)}>
                          Удалить
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          {/* <TablePagination
          component="div"
          count={users.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        /> */}
        </CardActions>
      </Card>
    </React.Fragment>
  );
};

OrdersTable.propTypes = {
  className: PropTypes.string,
  tickets: PropTypes.array.isRequired
};

export default OrdersTable;
